
import { Component, Watch } from 'vue-property-decorator'
import ProductSummary from './ProductSummary.vue'
import { PriceCalculator } from '@/mixins/PriceCalculator'
import { ModelValidator } from '@/mixins/ModelValidator'
import { namespace } from 'vuex-class'
import { mixins } from 'vue-class-component'
import { SummarySection } from '@/interfaces/SummarySection'
import { OptionApiModel } from '@/interfaces/OptionApiModel'
import { SummaryItem } from '@/interfaces/SummaryItem'
import { useOptionStore } from '@/store/modules/options'
const currentModel = namespace('currentModel')
const globalValues = namespace('globalValues')

@Component({
  components: {
    ProductSummary
  }
})
export default class ProductDetails extends mixins(
  PriceCalculator,
  ModelValidator
) {
  public optionStore = useOptionStore();
  private calculatingPrice = false;

  async mounted() {
    await this.validateModel()
    this.updatePrice()
    if (window.save || window.share) {
      this.toggleSummary()
    }
  }

  public showSummary = false;

  @currentModel.State
  public fetchedData!: boolean;

  @currentModel.Getter
  public totalPrice!: number;

  @currentModel.Action
  public updatePriceItems!: (payload: {
    priceSections: Array<SummarySection>;
  }) => void;

  @currentModel.Action
  public clearConfigurationKey!: () => void;

  @globalValues.Action
  public showAllDesigns!: () => Promise<boolean>;

  @globalValues.Action
  public showInspirationIdeas!: () => Promise<boolean>;

  public toggleSummary() {
    this.showSummary = !this.showSummary
  }

  public updatePrice() {
    console.debug('ProductDetails: updatePrice', { isBeingUpdated: this.isBeingUpdated })
    this.calculatingPrice = true
    this.calculatePrice(this.model)
      .then(priceSections => {
        priceSections.forEach(section => {
          section.items.forEach(item => {
            item.option = this.getPriceItemOption(item)
            if (item.substitutedFor) { item.substitutedFor.option = this.getPriceItemOption(item.substitutedFor) }
          })
        })
        this.updatePriceItems({ priceSections: priceSections })
      })
      .finally(() => {
        this.calculatingPrice = false
      })
  }

  public getPriceItemOption(priceItem: SummaryItem): OptionApiModel | undefined {
    const category = this.optionStore.allCategories.find(c => c.code === priceItem.categoryId)
    if (!category) { return undefined }

    const option = category.options.find(o => o.code === priceItem.optionId)
    if (!option) { return undefined }

    return option
  }

  @Watch('model', { immediate: false, deep: true })
  async onModelChanged() {
    this.clearConfigurationKey()

    console.debug('ProductDetails: onModelChanged 1', { isBeingUpdated: this.isBeingUpdated })

    if (this.isBeingUpdated) {
      return
    }

    const beingUpdatedOrValidated = await this.validateModel()

    console.debug('ProductDetails: onModelChanged 2', { beingUpdatedOrValidated, isBeingUpdated: this.isBeingUpdated })

    if (!beingUpdatedOrValidated) { this.updatePrice() }
  }

  @Watch('isBeingUpdated', { immediate: false, deep: true })
  async isBeingUpdatedChanged(currentlyUpdated: boolean) {
    console.debug('ProductDetails: isBeingUpdatedChanged 1', { currentlyUpdated })
    if (currentlyUpdated) {
      return
    }

    const beingUpdatedOrValidated = await this.validateModel()
    console.debug('ProductDetails: isBeingUpdatedChanged 2', { beingUpdatedOrValidated, isBeingUpdated: this.isBeingUpdated })
    if (!beingUpdatedOrValidated) {
      this.updatePrice()
    }
  }

  get mainLogoUrl() {
    return window.mainLogoUrl
  }
}
